import {useNavigate, createSearchParams} from "react-router-dom";

export function useNavigateParams(): (pathname: string, params: any, scrollPosition: any) => any {
  const navigate = useNavigate();

  return (pathname: string, params: any, scrollPosition: any): void => {
    navigate({pathname, search: `?${createSearchParams(params)}`}, {state: {scroll: scrollPosition}});
  }
}
